import { NavLink, Outlet, useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Home, ListChecks, CalendarCheck, TrendingUp, Wallet, LogOut, Sprout, ChefHat, CalendarDays } from "lucide-react";

const baseTabs = [
  { to: "/staff", icon: Home, label: "Trang chính", end: true, testid: "tab-home" },
  { to: "/staff/schedule", icon: CalendarDays, label: "Lịch", testid: "tab-schedule" },
  { to: "/staff/tasks", icon: ListChecks, label: "Việc", testid: "tab-tasks" },
  { to: "/staff/attendance", icon: CalendarCheck, label: "Công", testid: "tab-attendance" },
  { to: "/staff/kpi", icon: TrendingUp, label: "KPI", testid: "tab-kpi" },
  { to: "/staff/payslip", icon: Wallet, label: "Lương", testid: "tab-payslip" },
];

const kitchenTabs = [
  { to: "/staff", icon: Home, label: "Trang chính", end: true, testid: "tab-home" },
  { to: "/staff/kds", icon: ChefHat, label: "KDS", testid: "tab-kds" },
  { to: "/staff/schedule", icon: CalendarDays, label: "Lịch", testid: "tab-schedule" },
  { to: "/staff/tasks", icon: ListChecks, label: "Việc", testid: "tab-tasks" },
  { to: "/staff/attendance", icon: CalendarCheck, label: "Công", testid: "tab-attendance" },
  { to: "/staff/payslip", icon: Wallet, label: "Lương", testid: "tab-payslip" },
];

export default function StaffLayout() {
  const { user, loading, logout } = useAuth();
  const nav = useNavigate();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-stone-400">Đang khởi tạo…</div>;
  if (!user) return <Navigate to="/login" replace />;
  const tabs = user.role === "kitchen" ? kitchenTabs : baseTabs;

  return (
    <div className="min-h-screen flex flex-col bg-stone-50">
      <header className="bg-white border-b border-stone-200 px-4 py-3 flex items-center justify-between sticky top-0 z-30">
        <div className="flex items-center gap-2.5">
          <div className="w-9 h-9 rounded-sm flex items-center justify-center" style={{ background: "linear-gradient(135deg, #0F2A22, #186E54)" }}>
            <Sprout className="w-5 h-5 text-amber-300" />
          </div>
          <div>
            <div className="text-sm font-bold leading-tight">{user.full_name}</div>
            <div className="text-[10px] uppercase tracking-wider text-stone-500 font-bold">{user.role} • Thanh Sơn</div>
          </div>
        </div>
        <button onClick={() => { logout(); nav("/login"); }} className="text-stone-500 p-1" data-testid="staff-logout">
          <LogOut className="w-5 h-5" />
        </button>
      </header>

      <main className="flex-1 overflow-y-auto pb-20">
        <Outlet />
      </main>

      <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-stone-200 grid grid-cols-6 z-40" data-testid="staff-bottom-nav">
        {tabs.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.end}
            data-testid={t.testid}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center gap-0.5 py-2.5 tap-target ${
                isActive ? "text-emerald-900" : "text-stone-500"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <t.icon className="w-5 h-5" strokeWidth={isActive ? 2.25 : 1.75} />
                <span className={`text-[10px] ${isActive ? "font-bold" : "font-medium"}`}>{t.label}</span>
              </>
            )}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
